<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <tt-button-goto ttText="orderheadcalcs_new" ttGoto="custactedit" [ttGotoParms]="{ custact_no: '0', filterfield: 'order_internal_no', filtervalue: this.setting.order_internal_no }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListCalculations"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="orderheadcalcs_new" ttGoto="custactedit" [ttGotoParms]="{ custact_no: '0', filterfield: 'order_internal_no', filtervalue: this.setting.order_internal_no }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-4 p-5" [ttData]="itemsListCalculations"></tt-list>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="ordertype" [ttModel]="setting.ordertype_name" ttReadonly></tt-input>
        <tt-input *ngIf="setting.order_offer_no !== '0'" ttLabel="order_offer_no" [ttModel]="setting.order_offer_no" ttReadonly></tt-input>
        <tt-input *ngIf="setting.order_order_no !== '0'" ttLabel="order_order_no" [ttModel]="setting.order_order_no" ttReadonly></tt-input>
        <tt-input ttLabel="stat_cust_name" [ttModel]="setting.stat_cust_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>
